/**
 * NL类库
 *
 * @module nllib
 */

/**
 * tree转换成list
 *
 * @class nllib/src/tree-helper/tree_to_list
 * @static
 *
 * @param {object} pParameter
 *
 * @param {array} pParameter.tree 一维数组，通过property_name_for_children包含树状数据
 * @param {string} pParameter.property_name_for_children children的属性名称
 *
 * @return {array} 一维数组
 *
 * @demo src/tree-helper/tree_to_list/demo/tree_to_list.demo.js
 */

// const extend = require(`extend`);
// const Q = require(`q`);
const _ = require(`underscore`);
// const moment = require(`moment`);

const tree_to_list = function (pParameter) {
    if (!pParameter) pParameter = {};
    const tree = pParameter.tree;
    const property_name_for_children = pParameter.property_name_for_children || `children`;

    if (!_.isArray(tree)) {
        const msg = `tree_to_list parameter error, code=001`;
        console.error(msg);
        console.trace();
        return [];
    }

    const list = [];
    let stack = [
        ...tree,
    ];

    while (stack.length > 0) {
        const current_stack = stack.shift();
        list.push(current_stack);

        const children = current_stack[property_name_for_children];
        if (!_.isArray(children)) continue;
        if (children.length <= 0) continue;

        stack = stack.concat(children);
    }

    return list;
};

module.exports = tree_to_list;
